import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults, computed, ref, watchPostEffect } from 'vue'
import type { CSSProperties } from 'vue'

interface IProps {
  text: string
  /** 滚动持续时长，默认2秒 */
  duration?: number
  /** 匀速滚动，若设置此值，会重新计算滚动持续时长 */
  speed?: number
  /** 滚动及回滚前的停顿时长 */
  delay?: number
}
interface IEmits {
  (e: 'click'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    duration: { default: 2000 },
    speed: { default: 0 },
    delay: { default: 1000 }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { text: string, duration: number, speed: number, delay: number }





const elRef = ref<HTMLParagraphElement>()
const clientWidth = ref(0)
const scrollWidth = ref(0)

watchPostEffect(() => {
  const $el = elRef.value
  if ($el) {
    clientWidth.value = $el.offsetWidth
    scrollWidth.value = $el.scrollWidth
  }
})

const distance = computed(() => {
  return scrollWidth.value - clientWidth.value
})
const duration = computed(() => {
  const duration = props.duration || 2000
  const expectation = props.speed ? Math.round(1000 * distance.value / props.speed) : duration
  return expectation + props.delay * 2
})
const transitionStyle = computed(() => {
  return {
    '--slide-text-delay': `${props.delay}ms`,
    '--slide-text-duration': `${duration.value}ms`,
    '--slide-text-distance': `-${distance.value}px`,
  } as CSSProperties
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    ref_key: "elRef",
    ref: elRef,
    class: "slide-text",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("span", {
      class: "text",
      style: _normalizeStyle(_unref(transitionStyle))
    }, _toDisplayString(__props.text), 5)
  ], 512))
}
}

})